import React from 'react';
import { StyleSheet, View } from 'react-native';
import IconAvatar, {
  IconAvatarProps,
} from 'shared/components/vxl/avatar/IconAvatar/IconAvatar';
import UserAvatar, {
  UserAvatarProps,
} from 'shared/components/vxl/avatar/UserAvatar/UserAvatar';
import { Size } from 'shared/components/vxl/avatar/UserAvatar/UserAvatar.helpers';
import Icon, { IconProps } from 'shared/components/vxl/icon/Icon/Icon';
import { VXLComponent, VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

export interface ListItemLeadingAccessoryProps extends VXLComponent {
  name:
    | VXLComponentId.ICON
    | VXLComponentId.ICON_AVATAR
    | VXLComponentId.USER_AVATAR;
  props: IconProps | IconAvatarProps | UserAvatarProps;
}

const ListItemLeadingAccessory = ({
  accessory,
  isDisabled,
}: {
  accessory: ListItemLeadingAccessoryProps;
  isDisabled: boolean;
}) => {
  const { name, props } = accessory;

  if (name === VXLComponentId.ICON) {
    return (
      <View style={styles.container}>
        <Icon
          iconColor={
            isDisabled ? theme.color.text.muted : theme.color.text.primary
          }
          {...(props as IconProps)}
          iconSize="MD"
        />
      </View>
    );
  } else if (name === VXLComponentId.ICON_AVATAR) {
    return (
      <View style={styles.container}>
        <IconAvatar {...(props as IconAvatarProps)} />
      </View>
    );
  } else if (name === VXLComponentId.USER_AVATAR) {
    return (
      <View style={styles.container}>
        <UserAvatar
          {...(props as UserAvatarProps)}
          userAvatarSize={Size.Medium}
        />
      </View>
    );
  }
  return null;
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
});

export default ListItemLeadingAccessory;
